import { useState } from 'react';

type ToggleConfigProps = {
  name: string;
  value: boolean;
  text?: string;
  updateCallback: (name: string, value: boolean) => void;
  resetCallback?: (arg0: boolean) => void;
  onValue?: boolean | string;
  offValue?: boolean | string;
};

const ToggleConfig = ({
  name,
  value,
  text,
  updateCallback,
  resetCallback = undefined,
}: ToggleConfigProps) => {
  const [loading, setLoading] = useState(false);
  const [val, setValue] = useState(value);

  const handleUpdate = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    setValue(isChecked);

    setLoading(true);
    try {
      await updateCallback(name, isChecked);
    } catch (err) {
      console.error('Update failed:', err);
      // Revert on failure
      setValue(!isChecked);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="toggle">
      {text && <p>{text}</p>}
      <div className="toggleBox">
        <input
          name={name}
          type="checkbox"
          checked={val}
          onChange={handleUpdate}
          disabled={loading}
        />

        {!val && (
          <label htmlFor="" className="ofbtn">
            Off
          </label>
        )}

        {value && (
          <label htmlFor="" className="onbtn">
            On
          </label>
        )}
      </div>

      {resetCallback !== undefined && <button onClick={() => resetCallback(false)}>Reset</button>}
    </div>
  );
};

export default ToggleConfig;
